import { Button } from '@material-ui/core';
import React from 'react';

import { MoreActionsMenu } from '../../shared/components/MoreActionsMenu/MoreActionsMenu';
import { ActionsOption } from '../../shared/components/MoreActionsMenu/types/ActionsOption';
import { useDialog } from '../../shared/hooks/useDialog';
import { Font } from '../../shared/components/Font';
import { Text } from '../../shared/components/Text';
import { CreateMerchantDialog } from './components/CreateMerchantDialog';

export const MerchantListActions: React.FC = () => {
  const { opened, setOpened, toggleDialog } = useDialog();

  const actions: ActionsOption[] = [
    {
      display: <Text tId={'CREATE_MERCHANT'} />,
      onClick: () => toggleDialog(),
      iconName: 'add',
    },
  ];

  return (
    <>
      <MoreActionsMenu actionsOptionsArray={actions}>
        <Button>
          <Font variant={'subtitle2'} color={'textSecondary'}>
            <i
              className={'material-icons-outlined mr-2'}
              style={{ verticalAlign: '-5px', marginLeft: '-4px', fontSize: '1.5em' }}
            >
              menu
            </i>
            <Text tId={'ACTIONS'} />
          </Font>
        </Button>
      </MoreActionsMenu>
      <CreateMerchantDialog opened={opened} setOpened={setOpened} toggleDialog={toggleDialog} />
    </>
  );
};
